<template>
  <v-container class="shared-display-container">
    <v-chip small class="ml-2 pa-1" v-for="user in value" :key="user">
      {{ user }}
    </v-chip>
  </v-container>
</template>
<script>
export default {
  name: "UserShareListDisplay",
  props: {
    value: {
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
};
</script>
<style scoped>
.shared-display-container {
  padding: 0;
}
.v-chip {
  height: 22px;
}
.v-chip >>> .v-chip__close > .v-icon {
  font-size: 15px;
}
.v-chip >>> .v-chip__close {
  font-size: 15px;
  margin: 0 -2px 0 2px;
}
.v-chip >>> .v-chip__content {
  padding: 0 6px;
}
</style>
